import { apiClient } from './api.client'

/** file-service upload surface used for the product image (TO-416 REQ-005). */
export interface UploadUrlRequest {
	fileName: string
	contentType: string
	sizeBytes: number
	entityType: string
	entityId: string
}

const file = (id: string) => `/files/${encodeURIComponent(id)}`

export const fileUploadService = {
	requestUrl: async (body: UploadUrlRequest) =>
		(await apiClient.post<{ fileId: string; uploadUrl: string }>('/files/upload-url', body)).data,
	/**
	 * PUT the bytes to the presigned URL. A bare `fetch`, not `apiClient`, so the
	 * bearer token never reaches the storage host.
	 */
	putBytes: async (uploadUrl: string, bytes: File): Promise<void> => {
		const response = await fetch(uploadUrl, { method: 'PUT', body: bytes, headers: { 'Content-Type': bytes.type } })
		if (!response.ok) throw new Error(`Upload failed with status ${response.status}`)
	},
	confirm: async (fileId: string): Promise<void> => {
		await apiClient.post(`${file(fileId)}/confirm-upload`, {})
	},
	downloadUrl: async (fileId: string) =>
		(await apiClient.get<{ downloadUrl: string }>(`${file(fileId)}/download-url`)).data.downloadUrl,
}
